'use strict'


require('babel-polyfill')
import 'whatwg-fetch'
import ContainerDimensions from 'react-container-dimensions'
import imask from 'imask';
const $ = window.jQuery = require('jquery');
require('../../public/client-vendor/bigfoot/2.1.4/dist/bigfoot');
require('select2');
require('array.prototype.find');
const keycode = require('keycode');
require('what-input');
require('slick-carousel');
const Headroom = require('headroom.js');
require('./lib/append-around');
import internalLink from './lib/internal-link';
require('./lib/toggle-nav')();
require('./lib/retinafy')('[data-retina]');
require('./lib/loan-viewer');
require('./lib/view-preferences');
require('./lib/process-investment');
require('./lib/refresh-data');
require('./lib/sell-loan-part');
require('./lib/contact-map');
require('./lib/gallery');
require('./lib/multi-email-input');
require('./lib/currency-mask');
require('./lib/account-overview');
require('./lib/confirm-prefunding');
require('./lib/growth-graph');
require('./lib/lazy-load-updates');
require('./lib/process-loanpart-sale-cancellation');
require('./lib/team-profile-viewer');
require('./lib/track-user-client');
require('./lib/billboard-slideshow');
require('./lib/disable-onsubmit');
require('./lib/toggle-prefunding');
require('./lib/withdrawal-form-fees');
require('./lib/disable-onsubmit');
require('./lib/filter-updates');
const tabs = require('./lib/tabbed-content');
const videoModal = require('./lib/video-modal');
const inlineTableSort = require('./lib/inline-table-sort');
const confirmCancelLoanpartSale = require('./lib/confirm-loanpart-sale-cancellation');
const confirmLoanpartDecisions = require('./lib/confirm-loanpart-decisions');
const SuggestAddress = require('./lib/SuggestAddress');
const InvestmentForm = require('./lib/InvestmentForm');
const Accordion = require('./lib/Accordion');
const LoanPartsTable = require('./lib/LoanPartsTable');
const dismissables = require('./lib/dismissables');
const visibleIf = require('./lib/visible-if');
const notices = require('./lib/notices');
const notifications = require('./lib/notifications');
const formValidation = require('./lib/form-validation');



$('.js-debug');
confirmCancelLoanpartSale($('.js-cancel-loanpart-sale'));
confirmLoanpartDecisions($('.js-confirm-loanpart-decisions'));
notices({ className: 'js-notices' });
bigfoot();

new formValidation();

function bigfoot({ scope } = {}) {
  $.bigfoot({
    scope,
    useFootnoteOnlyOnce: false,
    activateOnHover: true,
    deleteOnUnhover: true,
    buttonMarkup: `
      <div class='bigfoot-footnote__container'>
        <button class='bigfoot-footnote__button'
          id='{{SUP:data-footnote-backlink-ref}}'
          type='button'
          data-footnote-number='{{FOOTNOTENUM}}'
          data-footnote-identifier='{{FOOTNOTEID}}'
          alt='See Footnote {{FOOTNOTENUM}}'
          rel='footnote'
          data-bigfoot-footnote='{{FOOTNOTECONTENT}}'>
          <svg class='bigfoot-footnote__button__circle' viewbox='0 0 6 6' preserveAspectRatio='xMinYMin'><circle r='3' cx='3' cy='3' fill='white'></circle></svg>
          <svg class='bigfoot-footnote__button__circle' viewbox='0 0 6 6' preserveAspectRatio='xMinYMin'><circle r='3' cx='3' cy='3' fill='white'></circle></svg>
          <svg class='bigfoot-footnote__button__circle' viewbox='0 0 6 6' preserveAspectRatio='xMinYMin'><circle r='3' cx='3' cy='3' fill='white'></circle></svg>
        </button>
      </div>`,
    contentMarkup: `
      <aside class='s-text  bigfoot-footnote is-positioned-bottom'
        data-footnote-number='{{FOOTNOTENUM}}'
        data-footnote-identifier='{{FOOTNOTEID}}'
        alt='Footnote {{FOOTNOTENUM}}'>
        <div class='bigfoot-footnote__wrapper'>
          <div class='bigfoot-footnote__content'>
            {{FOOTNOTECONTENT}}
          </div>
        </div>
        <div class='bigfoot-footnote__tooltip'></div>
      </aside>`
  });
}



$('[role=button]').on('keydown', function(e) {
  if(keycode(e) === 'space') {
    e.preventDefault();
    $(this).trigger('click');
  }
});



$('.js-open-video').on('click', function(e) {
  e.preventDefault();
  const $video = $(this);
  const video = $video.data('video');
  const timestamp = $video.data('timestamp');
  video && videoModal(video, { timestamp });
});



(async () => {
  if (window.loggedIn) {
    const [ React, reactDom, NotificationsContainer ] = await Promise.all([
      import('react'),
      import('react-dom'),
      import('./components/notifications-container')
    ])

    const target = document.body.appendChild(
      document.createElement('div')
    )

    reactDom.render((
      <NotificationsContainer.default
        feedApiUrl='/users/notifications'
        dismissApiUrl='/users/notifications/acknowledgements'
      />
    ), target)
  }
})();




(async() => {
  const targets = document.querySelectorAll('.js-investor-type-selector')

  if (targets) {
    const investorTypeSelector = await import('./lib/investor-type-selector')
    ;[ ...targets ].forEach(investorTypeSelector.default)
  }
})();



(() => {

	const selector = '.js-date-range';

	if(document.querySelector(selector)) {
		import('./lib/transactions');
	}

})();



(() => {

  const selector = '.js-select';
  const $elements = $(selector);

	$elements.select2({
		templateResult: (result, container) => {
			if(!result.id) {
				return result.text;
			}
	  	return result.text;
		}
	});

  $elements.each((i, element) => {

    const $element = $(element);

    $element.on('select2:open', () => {
      $('.select2-search__field')
        .addClass('[  c-input  c-input--text-based  ]');
    });

  });

})();



(() => {

  const $element = $('.js-main-header')
  const $spacer = makeSpacer($element)
  const activeClassName = 'is-active'

  const state = {
    active: null,
    height: getHeight(),
    y: getY()
  }

  const headroom = new Headroom($element[0], {
    classes: {
      pinned: 'is-pinned',
      unpinned: 'is-unpinned',
      top: 'is-top',
      notTop: 'is-not-top',
      bottom: 'is-bottom',
      notBottom: 'is-not-bottom'
    },
    onNotTop () {
      $spacer.height(getHeight())
    },
    onTop () {
      $spacer.height(0)
    },
    offset: state.y,
    tolerance: 5
  })

  headroom.init();

  function makeSpacer ($element) {
    const $spacer = $('<div />');
    $element.before($spacer);
    return $spacer;
  }

  function getY () {
    return $spacer.position().top
  }

  function getHeight () {
    return $element.height()
  }

  updateHeadroom()

  function updateHeadroom () {
    const nextState = {
      height: getHeight(),
      y: getY()
    }

    nextState.active = $(window).scrollTop() >= nextState.height + nextState.y

    if (nextState.y !== state.y) {
      headroom.offset = nextState.y
    }

    if (
      nextState.height === state.height
      && nextState.y === state.y
      && nextState.active === state.active
    ) {
      return requestAnimationFrame(updateHeadroom)
    }

    state.height = nextState.height
    state.y = nextState.y
    state.active = nextState.active

    if (nextState.active) {
      $element.addClass(activeClassName)
    } else {
      $element.removeClass(activeClassName)
    }

    requestAnimationFrame(updateHeadroom)
  }

})();



(() => {

  const tab = tabs();

  if(!tab) {
    return;
  }

  tab.on('route', hash => {
    if (hash === '#updates') {
      notifications.recordRead(window.loanId)
    }
  });

  (async () => {
    const targets = document.querySelectorAll('.js-dfl-graph')

    if (targets.length !== 0) {
      const [ React, reactDom, DflGraph ] = await Promise.all([
        import('react'),
        import('react-dom'),
        import('./components/dfl-graph')
      ])

      tab.on('route', hash => {
        if (hash !== '#updates') {
          return
        }

        ;[ ...targets ].forEach(target => {
          reactDom.render((
            <ContainerDimensions>
              {({ width  }) => (
                <DflGraph.default
                  drawdowns={JSON.parse(target.dataset.drawdowns)}
                  land={JSON.parse(target.dataset.land)}
                  gdv={Number(target.dataset.gdv)}
                  width={width}
                  height={width}
                  padding={[ 0, 0, 100, 50 ]}
                />
              )}
            </ContainerDimensions>
          ), target)
        })
      })
    }
  })();

})();



internalLink()



const CRAFTYCLICKS_TOKEN = 'acbfe-3d8dd-cf8b3-0158b';

const suggestAddress = new SuggestAddress({
  className: 'js-address-lookup',
  apiToken: CRAFTYCLICKS_TOKEN
});



$('.js-investment-form').each(function() {
  new InvestmentForm($(this));
});



$('.js-accordion').each(function() {
  new Accordion($(this));
});



(function() {

  const tables = [];
  const getOpen = () => tables.filter(table => table.state.open);
  const closeOpen = () => getOpen().forEach(table => table.close());
  const $allToggle = $('.js-toggle-all-loanparts');
  const showLabel = $allToggle.text();
  const hideLabel = $allToggle.data('hide-label');
  const accordionMode = false;

  const allOpen = () =>
    tables.every(table => table.state.open);

  const allClosed = () =>
    tables.every(table => !table.state.open);

  const applyAllTables = method =>
    tables.forEach(table => table[method]());

  const openAll = applyAllTables.bind(null, 'open');
  const closeAll = applyAllTables.bind(null, 'close');

  const toggleAll = () => allOpen() ?
    closeAll() :
    openAll();

  const updateTriggerLabel = () => {

    if(allOpen()) {
      $allToggle.text(hideLabel);
      return;
    }

    $allToggle.text(showLabel);

  };

  $allToggle.on('click', toggleAll);

  $('.js-loan-parts-table').each(function() {

    const controller = new LoanPartsTable($(this));

    if(accordionMode) {
      controller.on('open', closeOpen);
    }

    controller.on('open', updateTriggerLabel);
    controller.on('close', updateTriggerLabel);
    controller.on('append', id => bigfoot({ scope: `#${id}` }));

    tables.push(controller);

  });

})();



dismissables({
  dismissableClassName: 'js-dismissable',
  parentClassName: 'js-dismissable-parent',
  dismissClassName: 'js-dismiss',
  api: '/dismiss'
});



visibleIf({
  form: document.querySelector('.js-borrower-form'),
  elements: document.querySelectorAll(`[data-visibleIf='type-bridging']`),
  condition(form) {
    const type = document.querySelector(`[name='type']`);
    return type && type.value === 'bridging';
  }
});



visibleIf({
  form: document.querySelector('.js-borrower-form'),
  elements: document.querySelectorAll(`[data-visibleIf='type-development']`),
  condition(form) {
    const type = document.querySelector(`[name='type']`);
    return type && type.value === 'development';
  }
});



inlineTableSort.on('append', id => bigfoot({ scope: `#${id}` }));

(() => {
  const elements = document.querySelectorAll('.js-sortcode-input');

  [ ...elements ].forEach(element => {
    imask(element, {
      mask: '00-00-00'
    });
  });
})();
